'use strict';
import moment from 'moment-timezone';
angular.module('docketbook').
  controller('orderMobileDetailController', function (docketService, orderService, resourceService, userService, addressBookService, $rootScope, $window, $scope, $state, $stateParams, $mdpDatePicker, $mdpTimePicker, $mdToast, $mdBottomSheet, splitListInterface, $http, Restangular, accessControl, uuid, $timeout, scroll, geolocation) {
    mixpanel.track("Opened OrdersDetail Mobile");

    /***************************/
    /***** Setup Variables *****/
    /***************************/

    $scope.moment = moment;
    $scope.listItems = [];
    $scope.itemEdit = null;
    $scope.viewState = 'order';
    $scope.originalOrder = {};
    $scope.orderLoadingError = null;

    // Data
    $scope.currentUser = accessControl.currentUser();
    $scope.currentOrgGroup = accessControl.currentOrgGroup();
    $scope.currentOrg = accessControl.currentOrg();

    // Data
    if ($scope.currentOrg != null) {
      $scope.allResourceCategories = [];
      docketService.getTemplates({ published: true }, function (templates) {
        $scope.allTemplates = templates;
      });
      addressBookService.getAddressBook(null, function (addressBookFull) {
        $scope.addressBook = addressBookFull;
      });
    }

    /**********************/
    /**** Permissions *****/
    /**********************/

    $scope.userHasPermission = function (permissionName) {
      return accessControl.userHasPermission(permissionName);
    }

    $scope.userCanDoAction = userService.userCanDoAction;

    /*****************************/
    /**** Load Required Data *****/
    /*****************************/

    $scope.getResourceCategories = function () {
      $scope.allResourceCategories = [];
      resourceService.getResourceCategories({}, function (resourceCategories) {
        $scope.allResourceCategories = resourceCategories;
      }, function (err) {
        console.error('could not get resource categories', err);
      });
    }
    if ($scope.currentOrg != null) {
      $scope.getResourceCategories();
    }

    /**************************************/
    /***** Order Detail View Controls *****/
    /**************************************/

    $scope.openOrderMobile = function (order, tabToOpen) {
      $scope.orderLoadingError = null;
      $scope.viewState = 'order';
      var openTab = tabToOpen;
      if ($stateParams.openTab != null) {
        openTab = $stateParams.openTab;
      }
      $scope.prepareForOrderFromParent(openTab, order);
      orderService.getOrder(order, function (orderFull) {
        $scope.originalOrder = angular.copy(orderFull);
        $scope.loadOrderFromParent(orderFull);
      }, function (err) {
        $scope.orderLoadingErrorFull = err;
        $scope.orderLoadingError = "Error Loading Order";
      });
    }

    $scope.newOrder = function () {
      $scope.viewState = 'order';
      $scope.newOrderFromParent();
      $scope.originalOrder = {};
    }

    $scope.closeOrder = function () {
      var stateBack = {};
      if ($stateParams.stateTrail && $stateParams.stateTrail.length > 0) {
        stateBack = $stateParams.stateTrail[$stateParams.stateTrail.length - 1];
      }
      var stateOptions = {};
      if (stateBack.orderId) {
        stateOptions.orderId = stateBack.orderId;
      }
      if (stateBack.jobId) {
        stateOptions.jobId = stateBack.jobId;
      }
      if (stateBack.docketId) {
        stateOptions.docketId = stateBack.docketId;
      }
      if (stateBack.fromTab) {
        stateOptions.openTab = stateBack.fromTab;
      }
      if (stateBack.orgId) {
        stateOptions.orgId = stateBack.orgId;
      }
      if (stateBack.groupId) {
        stateOptions.groupId = stateBack.groupId;
      }
      if (stateBack.name) {
        if (stateBack.name == 'main.groupOrderDetail' && stateOptions.orderId == 'new') {
          $state.go('main.groupOrders', stateOptions);
        } else {
          $state.go(stateBack.name, stateOptions);
        }
      } else if ($scope.currentOrg != null) {
        $state.go('main.groupOrders', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      } else {
        $state.go('main.orders');
      }
    }

    $scope.deleteOrder = function (order) {
      orderService.deleteOrder(order.id, function () {
        $scope.closeOrder();
      }, function (err) {
        $scope.alertService.presentAutoAlert('deleteOrder', err);
      });
    }

    $scope.closeWithoutSave = function () {
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            var buttonActions = [{ title: 'Save', action: 'save', colour: 'green' }, { title: "Don't Save", action: 'dontSave', colour: 'red' }, { title: "Cancel", action: 'cancel', colour: 'grey' }];
            $scope.alertService.presentConfirmAlert('Unsaved Changes', 'Would you like to save changes before exiting?', buttonActions, function (actionSelected) {
              if (actionSelected == 'save') {
                orderService.saveOrder(diff, function (updatedOrder) {
                  $scope.closeOrder();
                });
              } else if (actionSelected == 'dontSave') {
                $scope.closeOrder();
              }
            });
          } else {
            $scope.closeOrder();
          }
        });
      } else {
        $scope.closeOrder();
      }
    }

    $scope.saveAndStay = function (order) {
      var newOrder = false;
      if (order.id == null) {
        newOrder = true;
      }
      order.loading = true;
      // get diffed order
      orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
        if (diffCount > 0 || newOrder == true) {
          orderService.saveOrder(diff, function (orderUpdated) {
            if (newOrder) {
              $scope.showToast('New Order Saved');
              $state.go('main.groupOrderDetail', { orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id, orderId: orderUpdated.id });
              //$scope.openOrderMobile(orderUpdated);
            } else {
              $scope.showToast('Order Changes Saved');
              $scope.openOrderMobile(orderUpdated.id, $scope.currentActiveTab());
            }
          }, function (err) {
            order.loading = false;
            $scope.alertService.presentAutoAlert('saveOrder', err);
          });
        } else {
          order.loading = false;
        }
      });
    }

    $scope.reDraftOrder = function (order) {
      $mdBottomSheet.hide();
      order.loading = true;
      order.loadingType = 'saving';
      orderService.reDraftOrder(order, function (orderUpdated) {
        $scope.openOrderMobile(orderUpdated.id);
      }, function (error) {
        order.loading = false;
        $scope.showToast('Error Re-Drafting Order');
      });
    }

    $scope.sendOrder = function (order) {
      // first save the order
      $mdBottomSheet.hide();
      order.loading = true;
      order.loadingType = 'saving';
      // get order diff
      orderService.getOrderDiff($scope.originalOrder, order, function (diff, diffCount) {
        orderService.saveOrder(diff, function (orderUpdated) {
          orderService.sendOrder(orderUpdated, function () {
            $scope.openOrderMobile(orderUpdated.id);
          }, function (error) {
            order.loading = false;
            $scope.alertService.presentAutoAlert('sendOrder', error);
          });
        }, function (error) {
          order.loading = false;
          $scope.alertService.presentAutoAlert('saveOrder', error);
        });
      });
    }

    $scope.acceptOrder = function (order) {
      $mdBottomSheet.hide();
      order.loading = true;
      order.loadingType = 'saving';
      orderService.acceptOrder(order, function () {
        $scope.openOrderMobile(order.id);
      }, function (error) {
        order.loading = false;
        $scope.alertService.presentAutoAlert('acceptOrder', error);
      });
    }

    $scope.rejectOrder = function (order) {
      $mdBottomSheet.hide();
      order.loading = true;
      order.loadingType = 'saving';
      orderService.rejectOrder(order, function () {
        $scope.openOrderMobile(order.id);
      }, function (error) {
        order.loading = false;
        $scope.alertService.presentAutoAlert('rejectOrder', error);
      });
    }

    $scope.finishOrder = function (order) {
      $mdBottomSheet.hide();
      order.loading = true;
      order.loadingType = 'saving';
      orderService.closeOrder(order, function () {
        $scope.openOrderMobile(order.id);
      }, function (error) {
        order.loading = false;
        $scope.alertService.presentAutoAlert('closeOrder', error);
      });
    }

    /********************************/
    /***** MAIN OPENING CONTROLS ****/
    /********************************/

    // Parameter controls
    $scope.detailControllerReady = function () {
      if ($stateParams.orderId != null) {
        if ($stateParams.orderId == 'new') {
          $scope.newOrder();
        } else {
          $scope.openOrderMobile($stateParams.orderId);
        }
      }
    }

    /******************************/
    /***** List View Controls *****/
    /******************************/

    $scope.showOrderDetail = function () {
      $scope.viewState = 'order';
    }

    $scope.selectCompanyForOrder = function (sourceList, companyType, cb) {
      $scope.viewState = 'company';
      $scope.selectCompanyCallback = cb;
      $scope.companySelectFromParent(sourceList, companyType, function (companySelected) {
        $scope.selectCompanyCallback(companySelected);
        $scope.showOrderDetail();
      });
    }

    $scope.selectContactForOrder = function (order, companyType, cb) {
      $scope.viewState = 'company';
      $scope.selectContactCallback = cb;
      var existingContacts = [];
      var selectedContact = null;
      if (companyType == 'customerContact') {
        if (order.supplierContact != null) {
          existingContacts.push(order.supplierContact);
        }
        if (order.customerContact != null) {
          selectedContact = order.customerContact;
        }
      } else if (companyType == 'supplierContact') {
        if (order.customerContact != null) {
          existingContacts.push(order.customerContact);
        }
        if (order.supplierContact != null) {
          selectedContact = order.supplierContact;
        }
      }
      $scope.selectCompanyType = companyType;

      $scope.contactSelectFromParent(existingContacts, selectedContact, function (contactSelected) {
        $scope.selectContactCallback(contactSelected);
        $scope.showOrderDetail();
      });
    }

    $scope.selectContactForShare = function (cb) {
      $scope.viewState = 'company';
      $scope.contactSelectFromParent(null, null, function (companySelected) {
        cb(companySelected);
        $scope.showOrderDetail();
      });
    }

    $scope.selectTemplateForOrder = function (sourceList, cb) {
      $scope.viewState = 'docketTemplate';
      $scope.selectTemplateCallback = cb;
      $scope.templateSelectFromParent(sourceList, function (templateSelected) {
        $scope.selectTemplateCallback(templateSelected);
        $scope.showOrderDetail();
      });
    }

    $scope.selectResourceForLine = function (cb) {
      $scope.viewState = 'resource';
      $scope.selectResourceCallback = cb;
      var order = $scope.getOrderFromParent();
      var templateCategories = null;
      if (order.template && order.template.interactionTemplates) {
        templateCategories = {};
        for (var i = 0; i < order.template.interactionTemplates.length; i++) {
          var interactionTemplate = order.template.interactionTemplates[i];
          for (var j = 0; j < interactionTemplate.actorCategories.length; j++) {
            if (templateCategories[interactionTemplate.actorCategories[j].id] == null) {
              templateCategories[interactionTemplate.actorCategories[j].id] = interactionTemplate.actorCategories[j];
            }
          }
        }
      }
      var categories = [];
      if (templateCategories == null) {
        categories = $scope.allResourceCategories;
      } else {
        for (var key in templateCategories) {
          categories.push(templateCategories[key]);
        }
      }
      var options = { categoriesList: categories };
      $scope.resourceSelectFromParent(options, function (resourceSelected) {
        $scope.selectResourceCallback(resourceSelected);
        $scope.showOrderDetail();
      });
    }

    $scope.selectOrganisationForOrder = function (order, cb) {
      $scope.viewState = 'organisation';
      $scope.selectOrganisationCallback = cb;
      $scope.assignDocket = {};
      $scope.assignDocket.organisations = accessControl.allowedOrganisations();
    }

    $scope.cancelSelectOrganisation = function () {
      $scope.showOrderDetail();
      $scope.selectOrganisationCallback(null);
    }

    $scope.selectOrganisationContinue = function (group) {
      $scope.showOrderDetail();
      $scope.selectOrganisationCallback(group);
    }

    /**************************/
    /***** Modal Controls *****/
    /**************************/

    $scope.newLineItemForOrder = function (order, cb) {
      $scope.newLineItemCallback = cb;
      $scope.newLineItemFromParent(order, function (lineItem) {
        $scope.newLineItemCallback(lineItem);
      });
    }

    $scope.editLineItemForOrder = function (order, item, cb) {
      $scope.editLineItemCallback = cb;
      $scope.editLineItemFromParent(order, item, function (lineItem) {
        $scope.editLineItemCallback(lineItem);
      });
    }

    /**************************************/
    /***** Infinite scrolling methods *****/
    /**************************************/

    $scope.loadingMoreItems = false;
    $scope.docketsListLoadingCount = 0;
    angular.element($window).bind('scroll', function () {
      if ($(window).scrollTop() + $(window).height() > $(document).height() - 20) {
        if ($scope.currentActiveTab() == 'Dockets' && !$scope.loadingMoreItems) {
          // load next page of dockets
          $scope.loadingMoreItems = true;
          $("#docketsLoadingMore").removeClass("hidden");
          $scope.loadOrderDocketsNextPage(function () {
            $scope.loadingMoreItems = false;
            $("#docketsLoadingMore").addClass('hidden');
          });
        } else if ($scope.currentActiveTab() == 'Jobs' && !$scope.loadingMoreItems) {
          // load next page of jobs
          $scope.loadingMoreItems = true;
          $("#jobsLoadingMore").removeClass('hidden');
          $scope.loadOrderJobsNextPage(function () {
            $scope.loadingMoreItems = false;
            $("#jobsLoadingMore").addClass('hidden');
          });
        }
      }
    });

    /************************************/
    /**** New Job / Docket Controls *****/
    /************************************/

    $scope.newJobForOrder = function () {
      // First check if order has been saved?
      var currentOrder = $scope.getOrderFromParent();
      orderService.validateCreateJob(currentOrder, function () {
        if (currentOrder != null && currentOrder.editing) {
          orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
            if (diffCount > 0) {
              swal({
                title: "Unsaved Changes",
                text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, close order.",
                cancelButtonText: "No, dont close order.",
                closeOnConfirm: true,
                closeOnCancel: true
              }, function (isConfirm) {
                if (isConfirm) {
                  $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                }
              });
            } else {
              $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupJobDetail', { jobId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      }, function (exceptions) {
        currentOrder.loading = false;
        $scope.alertService.presentValidationAlert('Some fields are required before you can create a job for this order.', exceptions);
      });
    }

    $scope.openJob = function (job) {
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close order.",
              cancelButtonText: "No, dont close order.",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isConfirm) {
              if (isConfirm) {
                $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              }
            });
          } else {
            $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupJobDetail', { jobId: job.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }

    $scope.newDocketForOrder = function () {
      // First check if order has been saved?
      var currentOrder = $scope.getOrderFromParent();
      orderService.validateCreateJob(currentOrder, function () {
        if (currentOrder != null && currentOrder.editing) {
          orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
            if (diffCount > 0) {
              swal({
                title: "Unsaved Changes",
                text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
                type: "warning",
                showCancelButton: true,
                confirmButtonColor: "#DD6B55",
                confirmButtonText: "Yes, close order.",
                cancelButtonText: "No, dont close order.",
                closeOnConfirm: true,
                closeOnCancel: true
              }, function (isConfirm) {
                if (isConfirm) {
                  $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
                }
              });
            } else {
              $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
            }
          });
        } else {
          $state.go('main.groupDocketDetail', { docketId: 'new', fromOrder: currentOrder.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
        }
      }, function (exceptions) {
        currentOrder.loading = false;
        $scope.alertService.presentValidationAlert('Some fields are required before you can create a docket for this order.', exceptions);
      });
    }

    $scope.openDocket = function (docket) {
      var currentOrder = $scope.getOrderFromParent();
      if (currentOrder != null && currentOrder.editing) {
        orderService.getOrderDiff($scope.originalOrder, currentOrder, function (diff, diffCount) {
          if (diffCount > 0) {
            swal({
              title: "Unsaved Changes",
              text: "You have some unsaved changes on this order, are you sure you want to close without saving?",
              type: "warning",
              showCancelButton: true,
              confirmButtonColor: "#DD6B55",
              confirmButtonText: "Yes, close order.",
              cancelButtonText: "No, dont close order.",
              closeOnConfirm: true,
              closeOnCancel: true
            }, function (isConfirm) {
              if (isConfirm) {
                $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
              }
            });
          } else {
            $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
          }
        });
      } else {
        $state.go('main.groupDocketDetail', { docketId: docket.id, fromTab: 'Jobs', orgId: $scope.currentOrg.id, groupId: $scope.currentOrgGroup.id });
      }
    }

    /******************/
    /***** Toasts *****/
    /******************/

    $scope.showToast = function (message) {
      var toast = {};
      if ($stateParams.device == 'desktop') {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000);
      } else {
        toast = $mdToast.simple()
          .textContent(message)
          .position('top right')
          .hideDelay(3000)
          .capsule(false)
          .parent(document.querySelectorAll('#toasterInner'));
      }
      $mdToast.show(toast).then();
    }

  });



// WEBPACK FOOTER //
// ./src/controllers/orders/mobileDetailController.js